import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import ToleranceIndicator from '../../QualityCheck/Creation/ToleranceIndicator';
import { CalculateToleranceFactorForOrderDetail } from '../../../Helpers/QualitySampleHelper';
import { useEffect } from 'react';

export default function OrderDetailToleranceInfoTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [toleranceFactor, setToleranceFactor] = React.useState(null);

    useEffect(() => {
        let factor = CalculateToleranceFactorForOrderDetail(JSON.parse(props.bomOut.productMetaData).find(x => x.MetaDataType === 1).MetaData[0])
        setToleranceFactor(factor)

    }, [])

    const rows = [
        createData('Weight', props.bomOut.productMetaData, props.bomOut.productMetaData),
        createData('Length', props.bomOut.productMetaData, props.bomOut.productMetaData),
        createData('Width', props.bomOut.productMetaData, props.bomOut.productMetaData),
        createData('Thickness', props.bomOut.productMetaData, props.bomOut.productMetaData),
    ];

    function createData(name, info, metaData) {

        info = JSON.parse(info)
        metaData = JSON.parse(metaData)
        info = info.find(x => x.MetaDataType === 1)
        metaData = metaData.find(x => x.MetaDataType === 1).MetaData

        if (name === 'Weight') {
            info = info.MetaData[0].MassDensity.Value + " " + info.MetaData[0].MassDensity.Uom
        }
        else if (name === 'Length') {
            info = info.MetaData[0].Length.Value + " " + info.MetaData[0].Length.Uom
        }
        else if (name === 'Width') {
            info = info.MetaData[0].Width.Value + " " + info.MetaData[0].Width.Uom
        }
        else {
            info = info.MetaData[0].Thickness.Value + " " + info.MetaData[0].Thickness.Uom
        }


        return { name, info, metaData };
    }

    return (
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headCell}></TableCell>
                        <TableCell className={classes.headCell}></TableCell>
                        <TableCell className={classes.headCell} align="center">{t("Tolerance")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {t(row.name)}
                            </TableCell>
                            <TableCell className={classes.infoCell}>{row.info}</TableCell>
                            <TableCell className={classes.toleranceCell}>
                                {toleranceFactor && 
                                <ToleranceIndicator toleranceFactor = {toleranceFactor} name={row.name} metaData={row.metaData}></ToleranceIndicator>}                                
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const useStyles = makeStyles({

    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px",
        width: "15%"
    },
    infoCell: {
        padding: "3px !important",
        paddingRight: "10px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    toleranceCell: {
        padding: "3px !important",
        border: "none",
        width: "50%",
        boxSizing: "border-box"
    },
    headCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "3px",
        paddingTop: "0px",
        border: "none",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
});